<template>
  <v-layout column>
    <v-flex :style="`max-height: ${height}px; overflow-y: auto;`">
      <v-data-table
        :headers="tableData.headers"
        :items="tableData.items"
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th class="dlBtn-holder">
              <div id="downloadButton" @click="downloadData(tableData)"></div>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                header.sortable ? 'column sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
                ]"
              @click="changeSort(header.value)"
            >
              <v-layout row>
                <div>{{ header.text }}</div>
                <div v-show="header.sortable !== false">
                  <v-icon small>arrow_upward</v-icon>
                </div>
              </v-layout>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr>
            <td></td>
            <td
              v-for="header in tableData.headers"
              :key="header.value"
              :class="[
              ]"
              @click="clickItem (props.item)"
            >
              {{ props.item[header.value] | formatNumberValues(header.value) }}
            </td>
            <td></td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import {downloadCSV, thousandsSeparator} from '../util'
import {NO_NORM} from '../constants'

export default {
  name: 'table-chart',
  props: ['chartData', 'height'],
  data () {
    return {
      'noNorm': NO_NORM,
      pagination: {
        'sortBy': 'indicatorValue',
        'descending': true,
        'rowsPerPage': 10
      }
    }
  },
  computed: {
    selectedIndicatorWording () {
      let indicatorText = this.$store.state.selectedIndicator.text
      if (this.selectedNormalization.key !== this.noNorm.key) {
        indicatorText += ' ' + this.selectedNormalization.name
      }
      return indicatorText
    },
    selectedNormalization () {
      return this.$store.state.selectedNormalization
    },
    tableData () {
      if (this.chartData.data.length === 0) {
        return {headers: [], items: []}
      }

      let firstDim = this.chartData.group_by[0]
      let secondDim = this.chartData.group_by[1]
      let thirdDim = this.chartData.group_by[2]

      let headers = [
        // geography or topic
        {
          text: firstDim.charAt(0).toUpperCase() + firstDim.slice(1),
          align: 'left',
          value: firstDim,
          class: 'secondary',
          sortable: true
        }
      ]

      if (secondDim !== undefined) {
        // year - need not be sortable as users can only select individual years at this time
        headers.push({
          text: secondDim.charAt(0).toUpperCase() + secondDim.slice(1),
          align: 'center',
          value: secondDim,
          class: 'secondary',
          sortable: false
        })
      }

      if (thirdDim !== undefined) {
        // complement
        headers.push({
          text: thirdDim.charAt(0).toUpperCase() + thirdDim.slice(1),
          align: 'right',
          value: thirdDim,
          class: 'secondary',
          sortable: true
        })
      }

      headers.push({
        text: this.selectedIndicatorWording,
        value: 'indicatorValue',
        align: 'right',
        class: 'secondary',
        sortable: true
      })

      let items = this.chartData.data.map(function (d) {
        let result = {}
        result['code'] = d[firstDim]
        result[firstDim] = this.getFullName(d[firstDim])
        result[secondDim] = this.getFullName(d[secondDim])
        result[thirdDim] = this.getFullName(d[thirdDim])
        result['complementCode'] = d[secondDim]
        result['indicatorValue'] = d.value
        return result
      }, this)

      return {headers: headers, items: items}
    }
  },
  filters: {
    formatNumberValues (value, headerValue) {
      if (headerValue === 'indicatorValue') {
        if (typeof value === 'string') {
          // fix for API returning number values as strings
          // (API 3.1 2019-07-31, still ongoing in API 4.2, 2020-05-18)
          value = Number(value)
        }
        return thousandsSeparator(value, 3, 'en')
      } else {
        // ignore non-num value table data
        return value
      }
    }
  },
  methods: {
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = !this.pagination.descending
      }
    },
    clickItem (item) {
      this.$emit('click:item', {firstDimCode: item.code, complementCode: item.complementCode})
    },
    getFullName (d) {
      return this.$store.state.geoMap.has(d) ? this.$store.state.geoMap.get(d) : this.$store.state.topicMap.has(d) ? this.$store.state.topicMap.get(d).text : d
    },
    downloadData (data) {
      downloadCSV(data)
    }
  }
}
</script>

<style scoped>
#downloadButton {
  background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQzMy41IDQzMy41IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MzMuNSA0MzMuNTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnIGlkPSJmaWxlLWRvd25sb2FkIj4KCQk8cGF0aCBkPSJNMzk1LjI1LDE1M2gtMTAyVjBoLTE1M3YxNTNoLTEwMmwxNzguNSwxNzguNUwzOTUuMjUsMTUzeiBNMzguMjUsMzgyLjV2NTFoMzU3di01MUgzOC4yNXoiIGZpbGw9IiMwMDAwMDAiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K);
  background-size: 16px 16px;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.dlBtn-holder {
  width: 2em;
  padding-right: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue